// extracted by mini-css-extract-plugin
module.exports = {"lockIcon":"RoleSwitch_lockIcon__3ao9k"};